import React, {InputHTMLAttributes, useState} from 'react';


interface CustomInputPropsInterface extends React.InputHTMLAttributes<HTMLInputElement> {
    checkPattern?: RegExp
}

const Input = React.forwardRef<HTMLInputElement, CustomInputPropsInterface>(
    (props, ref)=> {
        const { pattern, ...rest } = props
        const [inputValue, setInputValue] = useState<string>("")

        function patternChecked(target: any){
            let inputText = target.value
            if(pattern){
                inputText = inputText.replace(pattern, "")
            }
            setInputValue(inputText)
        }

        return <input { ...rest } value={inputValue} onChange={e=> patternChecked(e.currentTarget)} ref={ref} />
    }
)

export default Input;